import { Component } from '@angular/core';
import { LoginComponent } from '@tango/app/login/login.component';

@Component({
  templateUrl: './login.component.html'
})
export class BankLoginComponent extends LoginComponent {
}
